import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {
    CnCommissionRuleObjectBaseViewComponent
} from '../cn-commission-rule-object-base-view/cn-commission-rule-object-base-view.component';

/**
* Side (compact) view of the CommissionRule object component (FR-4).
*
* Shows the essential left-nav sections in a side/mini-side context:
* Allgemein / Staffeln / Bedingungen. Full configuration happens in the full view.
*/
@Component({
    selector: 'mvs-cn-commission-rule-side',
    templateUrl: './cn-commission-rule-side.component.html',
    styleUrls: ['./cn-commission-rule-side.component.scss'],
    standalone: false
})
export class CnCommissionRuleSideComponent extends CnCommissionRuleObjectBaseViewComponent
    implements OnInit, OnChanges, OnDestroy {

    constructor(protected override activatedRoute: ActivatedRoute) {
        super(activatedRoute);
    }

    /**
    * Compact left-nav items (G6: action-based, fa-solid icons, German labels with umlauts).
    */
    loadSideBarMenuItems(): void {
        this.navigationItems = [
            {
                label: 'Allgemein',
                action: 'cn.CommissionRule',
                tooltip: 'Allgemein',
                icon: 'fa-solid fa-sliders text-xl',
                toggleable: false,
                default: true
            },
            {
                label: 'Staffeln',
                action: 'cn.CommissionRuleTier',
                tooltip: 'Staffeln',
                icon: 'fa-solid fa-layer-group text-xl',
                toggleable: false,
                default: false
            },
            {
                label: 'Bedingungen',
                action: 'cn.CommissionCondition',
                tooltip: 'Bedingungen',
                icon: 'fa-solid fa-filter-circle-dollar text-xl',
                toggleable: false,
                default: false
            }
        ];
    }

    override ngOnInit(): void {
        this.loadSideBarMenuItems();
        this.initComponent();
        super.ngOnInit();
    }

    /**
    * Re-render the section widgets when the bound objectIdentifier changes.
    * Delegates to the shared base view (G2.3 / G4.6).
    */
    override ngOnChanges(changes: SimpleChanges): void {
        super.ngOnChanges(changes);
    }

    override ngOnDestroy(): void {
        super.ngOnDestroy();
    }
}
